import { createClient } from "@supabase/supabase-js";
import * as Sentry from "@sentry/react";

const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "";
const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? "";

// Fallback to placeholder URL so design-sync / test builds that don't define
// VITE_SUPABASE_URL don't crash at module init time. In production these env
// vars are always injected by Vite, so the fallback never fires.
export const supabase = createClient(
  SUPABASE_URL || "https://placeholder.supabase.co",
  SUPABASE_ANON_KEY || "placeholder"
);

/** Signs in anonymously, capturing any auth error to Sentry. Returns the session or null. */
export async function signInAnonymously() {
  const { data, error } = await supabase.auth.signInAnonymously();
  if (error) Sentry.captureException(error, { tags: { context: "anonymous_sign_in" } });
  return data.session;
}
